export default {
    'diagram3-3a1': {
        'diagram-number': '3.',
        'elements': {
            'one': 'Deepwater fish contain trimethylamine N-oxide (TMAO), which maintains the osmotic pressure needed to keep water from diffusing into their cells',
            'two': 'However, TMAO stops working below 7,000 meters, presumably dooming any fish swimming deeper to “drown”',
            'three': 'Thus the chances of photographing fish in the Hadad trenches (between 8,000 and 10,000 meters) are remote',
        }
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram3/i18n/en.js